import { Assets } from "../../assets/svgs-index";
import { Category } from "../../core/models/category.model";
import './CategoryCard.scss';

interface CategoryCardProps {
  category: Category,
  onClick: () => void
}
const CategoryCard = (props: CategoryCardProps) => {
  const { category } = props;
  return (
    <div className="category-card align-center" onClick={props.onClick} role="button">
      <div className="category-icon">
        <img src={Assets.vertical.icon(category?.icon)} alt="category-icon" />
      </div>
      <div className="category-name mt-1">{category?.name}</div>
    </div>
  );
}

export default CategoryCard;
